module.exports = __webpack_public_path__ + "static/media/ft-min.48b11fba.png";